import React, { Component } from 'react';
import _ from 'lodash';

import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { userStyles } from "../styles";
import {
	WithStyles,
	createStyles,
	Typography,
} from '@material-ui/core';
import { nextPage, 
		 previousPage, 
		 firstPage, 
		 updateCurrentPage,
		 lastPage } from "../actions/contentRequestActions";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { Tabs } from "../types/Constants";

const styles = (theme: Theme) => createStyles({
	root: {
		flexShrink: 0,
		color: theme.palette.text.secondary,
		marginLeft: theme.spacing.unit * 2.5,
		marginRight: theme.spacing.unit,
		'& p': {
			color: 'rgb(66 74 85)',
    		verticalAlign: 'middle'
		}
	},
	iconButton: {
		padding: '5px 0px',
		borderRadius: 2
	}
});

//@ts-ignore
interface CR_PaginationProps extends WithStyles<typeof styles> {
	classes: any,
	count: number,
	rowsPerPage: number,
	nextPage: Function,
	previousPage: Function,
	firstPage: Function,
	lastPage: Function,
	updateCurrentPage: Function,
	activeTab: Tabs,
	sentRequestsTotalPages: number,
	receivedRequestTotalPages: number,
	pageNumber: number,
	pageSize: number,
	sentContentRequestsData: any,
	receivedContentRequestsData: any
	totalCount:number
}

class CR_Pagination extends Component<CR_PaginationProps>{

	getPaginationInfo(): React.ReactNode {
		const totalPages = this.props.activeTab === Tabs.SentRequest ? 

		_.get(this.props.sentContentRequestsData, 'length', 0) < this.props.pageSize ? 
		(_.get(this.props.sentContentRequestsData, 'length', 0)):
		// (this.props.sentRequestsTotalPages * this.props.pageSize) 
		(this.props.totalCount) 
	
		:

		(_.get(this.props.receivedContentRequestsData, 'length', 0) < this.props.pageSize) ?
		(_.get(this.props.receivedContentRequestsData, 'length', 0)):
		(this.props.receivedRequestTotalPages * this.props.pageSize )

		console.log('::::::Total Pages:::::::::', totalPages);

		return this.props.activeTab === Tabs.SentRequest ?
			` ${(totalPages > 0 ? 1 : 0) + ((this.props.pageNumber - 1) * this.props.pageSize)} - ${(_.get(this.props.sentContentRequestsData, 'length', 0) < this.props.pageSize) 
			&& this.props.pageNumber === 1 ? 
			(_.get(this.props.sentContentRequestsData, 'length', 0)) : 
			(20 + ((this.props.pageNumber - 1) * this.props.pageSize)) } 
					of 
			${ (_.get(this.props.sentContentRequestsData, 'length', 0) < this.props.pageSize) && this.props.pageNumber === 1 ? 
					(_.get(this.props.sentContentRequestsData, 'length', 0)):
					(this.props.totalCount)}`:
			` ${(totalPages > 0 ? 1 : 0) + ((this.props.pageNumber - 1) * this.props.pageSize)} - ${  (_.get(this.props.receivedContentRequestsData, 'length', 0) < this.props.pageSize) && this.props.pageNumber === 1 ? 
			(_.get(this.props.receivedContentRequestsData, 'length', 0)) : 
			(20 + ((this.props.pageNumber - 1) * this.props.pageSize))} 
					of ${(_.get(this.props.receivedContentRequestsData, 'length', 0) < this.props.pageSize) && this.props.pageNumber === 1 ?
					(_.get(this.props.receivedContentRequestsData, 'length', 0)):
					(this.props.receivedRequestTotalPages * this.props.pageSize )}` 
	}

	render() {
		const { classes, count, rowsPerPage } = this.props;
		return (
			<>
				<div className={classes.root}>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={() => {
							
					   this.props.firstPage({
							activeTab: this.props.activeTab
						})
						// this.props.updateCurrentPage(1);			
					   }}
						disabled={this.props.pageNumber === 1}
						aria-label="First Page"
					>
						{   this.props.pageNumber === 1 ?
							<img src="/assets/svg/myLibrary/pagination/double-left-arrow.svg" alt="doubleArrow"/> :
							<img src="/assets/svg/contentRequest/nav-double-arrow.svg" alt="doubleArrow"/>
						}
					</IconButton>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={() => {
				
						this.props.previousPage({
							activeTab: this.props.activeTab,
							pageNumber: this.props.pageNumber - 1
						})
						// this.props.updateCurrentPage(this.props.pageNumber - 1);

					}
					}
						disabled={this.props.pageNumber === 1}
						aria-label="Previous Page"
					>
						{
							this.props.pageNumber === 1 ?
							<img src="/assets/svg/myLibrary/pagination/single-left-arrow.svg" alt="singleArrow"/> :
							<img src="/assets/svg/contentRequest/nav-arrow.svg" alt="singleArrow"/>
						}
					</IconButton>
					<Typography style={{ display: 'inline' }} variant="body1">
						{this.getPaginationInfo()}
					</Typography>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={() => {
						this.props.nextPage({
							activeTab: this.props.activeTab,
							pageNumber: this.props.pageNumber + 1
						})
						// this.props.updateCurrentPage(this.props.pageNumber + 1);
					}
					}
						disabled={this.props.activeTab === Tabs.SentRequest ? 
									(this.props.pageNumber === this.props.sentRequestsTotalPages) :
									this.props.pageNumber === this.props.receivedRequestTotalPages}
						aria-label="Next Page"
					>
						<img src="/assets/svg/myLibrary/pagination/arrow-right.svg" alt="singleArrow"/>
					</IconButton>
					<IconButton classes={{ root: classes.iconButton }}
						onClick={() => {
						let pageNo = this.props.activeTab === Tabs.SentRequest ?  this.props.sentRequestsTotalPages : this.props.receivedRequestTotalPages;	
						this.props.lastPage({activeTab: this.props.activeTab})
						// this.props.updateCurrentPage(pageNo);
					}}
						disabled={this.props.activeTab === Tabs.SentRequest ? 
							this.props.pageNumber === this.props.sentRequestsTotalPages :	
							this.props.pageNumber === this.props.receivedRequestTotalPages
						}
						aria-label="Last Page"
					>
						<img src="/assets/svg/myLibrary/pagination/double-arrow-right.svg" alt="singleArrow"/>
					</IconButton>
				</div>
			</>
		);
	}


}

const mapStateToProps = (state: any) => ({
    activeTab: state.contentRequestReducer.contentRequestReducer.activeTab,
    sentRequestsTotalPages: state.contentRequestReducer.contentRequestReducer.sentRequestsTotalPages,
    receivedRequestTotalPages: state.contentRequestReducer.contentRequestReducer.receivedRequestTotalPages,
    pageNumber: state.contentRequestReducer.contentRequestReducer.pageNumber,
    pageSize: state.contentRequestReducer.contentRequestReducer.pageSize,
	sentContentRequestsData: state.contentRequestReducer.contentRequestReducer.sentContentRequestsData,
	receivedContentRequestsData: state.contentRequestReducer.contentRequestReducer.receivedContentRequestsData,
    totalCount: state.contentRequestReducer.contentRequestReducer.totalCount,
  });

  const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
		nextPage,
		previousPage,
		firstPage,
		lastPage,
		updateCurrentPage
    },
    dispatch
  );

export default connect(
    mapStateToProps,
    mapDispatchToProps
      // @ts-ignore
  )(withStyles(styles)(CR_Pagination));

